import { render } from "./documents-uploader.vue?vue&type=template&id=92ac8d10"
import script from "./documents-uploader.vue?vue&type=script&lang=js"
export * from "./documents-uploader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/rspack-vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__